export default "__VITE_ASSET__c7f3ac6a__"